export default __webpack_public_path__ + "static/media/misc-closetA-1024w.26ad9fe4.avif";